import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import ChinaAddressV4Data from '../../common/ChinaAddressV4Data.json'
import uploadoss from '@/components/uploadoss'
import plupload from 'plupload'
import * as $ from 'jquery'
export default {
name: 'submitOrder',
directives: {
TransferDom
},
components: {
XHeader,
CheckIcon,
Group,
XButton,
Popup,
Confirm,
XSwitch,
XAddress,
Loading,
uploadoss,
XInput
},
data () {
return {
enclosureName: "",
enclosurePath: "",
issecrecy:false,
secrecy:'0',
remarks:'',
integralAmt:0,

secrecylists:[{
name:'不保密',
code:'0',
},{
name:'该订单图纸保密',
code:'1',
},{
name:'所有订单图纸保密',
code:'2',
},],

resource: 0, //快递费用支付方式    0（在线）  1（到付陆运）  2（到付空运）
resource1:0,  //顺丰陆运     京东陆运
resourceLists: ["在线支付", "到付陆运", "到付空运"],
resourceLists1: ["顺丰陆运", "京东陆运"],



invoiceIditem:{},
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
showVoucher: false,
showMoreInvoice: false,
orderList: [],
expressPrice: 0,
addressObj: {},
haveAddress: true,
selectInvoiceType: '',
selectInvoiceTitle: '',
showConfirm: false,
showAddress: false,
show: false,
deling: false,
confirmType: '',
singleDelItem: '',
singleDelIndex: '',
invoiceData: {
title: '',
shoujihao: '',
youxiang: '',
taxNum: '',
invoiceAddress: '',
invoicePhone: '',
openingBank: '',
bankAccount: '',
},
activeAddressIndex: 0,
voucherList: [],
voucherPrice: '',
voucherId: undefined,
activeVoucherIndex: -1,
addressData: [],
selectAddressData: ChinaAddressV4Data,
showNewAddress: false,
isDefaultAddress: false,
NewAddressData: {
token: this.getCookie('_token'),
address: [],
receiver: '',
province: '',
city: '',
district: '',
detail: '',
phone: '',
tel: '-',
},
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
showSubmitOrderTipsDialog: false,
showSubmitSplitOrderTipsDialog: false,
tipsText: '',
hasTipsFLag: false,
tipsFLag: '',
isNoHeadEvent: true,
cartIdsArr: [],
head: {
btnName: '上传附件',
ossdata: [],
fileArr: [],
},
accessoryInfo: {},
deliveryTimeList: [],
selectedDeliveryDaysIndex: 0,
selectedDeliveryDaysItem: {},
totalPriceZkj: 0
}
},
methods: {
gxsecrecy(val){
this.secrecy=val

},
selectAddress (item,index) { //选择地址
this.addressObj = item

this.activeAddressIndex = index
this.getExpressPrice(this.addressObj.province,this.selectInvoiceType)
setTimeout(() => {
this.showAddress = false
}, 100);
},
onShadowChange () {
this.NewAddressData.province = this.$refs.addressArea.nameValue.split(' ')[0]
this.NewAddressData.city = this.$refs.addressArea.nameValue.split(' ')[1]
this.NewAddressData.district = this.$refs.addressArea.nameValue.split(' ')[2]
},
reFlag () {
this.isNoHeadEvent = true
},

showossdataHead(data) {
this.ossdata = data;
console.log(this.ossdata);
},
showossurlHead(fileArr) {
console.log(fileArr)
this.accessoryInfo = fileArr[0]
},
submitNewAddress () { //点击新增地址确定按钮
if(this.$trim(this.NewAddressData.province) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请选择所在地区'
})
return false;
}
if(this.$trim(this.NewAddressData.detail) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入详细地址'
})
return false;
}
if(this.$trim(this.NewAddressData.receiver) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入收货人姓名'
})
return false;
}
if(this.$trim(this.NewAddressData.phone) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入手机号码'
})
return false;
}else if(!this.phoneReg.test(this.$trim(this.NewAddressData.phone))){
this.$vux.toast.show({
type: 'warn',
text: '手机号码格式有误'
})
return false;
}
console.log(JSON.parse(JSON.stringify(this.NewAddressData)))
this.$request.post('/address/add',this.NewAddressData).then(data => {
if(data.code == 0){
this.showNewAddress = false
this.$vux.toast.show({
type: 'success',
text: '新增成功'
})
if(this.isDefaultAddress){
this.setdefault(data.obj.id)
}
setTimeout(() => {
this.getAddressList()
}, 50);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
setdefault (id) {
this.$request.post('/address/setdefault',{
token: this.$token,
id
}).then(data => {
if(data.code == 0){

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
del(){
this.enclosureName=''
this.enclosurePath=''
},
regNum (e,item,index) {
let val = Number(e.target.value)
let reg = /^[1-9]\d*$/
if(!reg.test(val)){
val = 1
}
item.qty = val
item.singlePrice = item.salePrice*1000 * item.qty*1000/1000000
this.updateQty(item.id,item.qty)
},
add (item,index) {  //数量+1
item.qty += 1
item.singlePrice = item.salePrice*1000 * item.qty*1000/1000000
this.updateQty(item.id,item.qty)
},
subtract (item,index) { //数量-1
if(item.qty > 1){
item.qty -= 1
}
item.singlePrice = item.salePrice*1000 * item.qty*1000/1000000
this.updateQty(item.id,item.qty)
},
updateQty (id, num) {
this.$request.post('/cart/updateqty',{
cartId: id,
qty: num
}).then(data => {
if(data.code == 0){
console.log('数量变更成功')
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
submitOrderTips () {
this.$request.post('/order/remind',{

}).then(data => {

if(data.code == 0){
if(data.obj.length != 0){
this.tipsText = data.obj[0].remindContent
this.hasTipsFLag = true
this.tipsFLag = true
}else{
this.tipsFLag = false
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
closeShowSubmitSplitOrderTipsDialog () {
this.showSubmitSplitOrderTipsDialog = false
if(this.hasTipsFLag){
this.tipsFLag = true
}
},
stillSubmit () {
this.tipsFLag = false
this.showSubmitOrderTipsDialog = false
this.submitOrder()
},
getVoucher () {
this.$request.post('/couponDetail/couponList',{
status: '0'
}).then(data => {
if(data.code == 0){

let date = (new Date()).toLocaleDateString().replace(/\//g,',')
let start = new Date(date)
function end (b) {
return new Date(b)
}
data.obj.forEach((item, index) => {
if(item.status == '0'){
(end(item.endTime.replace(/-/g,','))-start)/(1000*60*60*24) < 15 ? item.beAboutToExpire = true : item.beAboutToExpire = false
}
});
this.voucherList = data.obj

for(var i=0;i<this.voucherList.length;i++){

if(this.voucherList[i].endTime.split('-')[0]=='2022'){
var img = "";
if (  this.voucherList[i].type.indexOf("满减") != -1   ) {


if (this.voucherList[i].amt == 20) {
img = require('../../assets/images/YD20.png')
} else if (this.voucherList[i].amt == 30) {
img =  require('../../assets/images/YD30.png')
} else if (this.voucherList[i].amt == 50) {
img =  require('../../assets/images/YD50.png')
} else if (this.voucherList[i].amt == 100) {
img =  require('../../assets/images/YD100.png')
} else if (this.voucherList[i].amt == 200) {
img =  require('../../assets/images/YD200.png')
} else if (this.voucherList[i].amt == 300) {
img =  require('../../assets/images/YD300.png')
}
this.voucherList[i]["img"] = img;
} else if (this.voucherList[i].type.indexOf("新人") != -1) {


if (this.voucherList[i].amt == 20) {
img = require("../../assets/images/XA20.png");
} else if (this.voucherList[i].amt == 30) {
img = require("../../assets/images/XA30.png");
} else if (this.voucherList[i].amt == 50) {
img = require("../../assets/images/XA50.png");
}

this.voucherList[i]["img"] = img;
} else {

this.voucherList[i]["img"] = "";
}

}else{

if(this.voucherList[i].type=='满减优惠券'){
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/Q20.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/Q50.png");
}else if(this.voucherList[i].amt==100){
this.voucherList[i]['img']=require("../../assets/images/Q100.png");
}else if(this.voucherList[i].amt==200){
this.voucherList[i]['img']=require("../../assets/images/Q200.png");
}else if(this.voucherList[i].amt==500){
this.voucherList[i]['img']=require("../../assets/images/Q500.png");
}else if(this.voucherList[i].amt==1000){
this.voucherList[i]['img']=require("../../assets/images/Q1000.png");
}
this.voucherList[i]['title']='待使用'

}else{// 新人券
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/XA20.png");
}else if(this.voucherList[i].amt==30){
this.voucherList[i]['img']=require("../../assets/images/XA30.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/XA50.png");
}

}
}







}













}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
selectVoucher (item, index) {
console.log(item)
console.log('totalMoney',this.totalMoney);



var fgdata=item.range.split(',')
var fgdata1=[]
for(var t=0;t<fgdata.length;t++){
if(fgdata[t]=='产品中心'){
fgdata1[t]='productCenter'
}else if(fgdata[t]=='打印'){
fgdata1[t]='print'
}else{
fgdata1[t]='01'
}

}


var isobj=false
for(var i=0;i<fgdata1.length;i++){
if(this.$route.query.type==fgdata1[i]){

isobj=true
}



}


if(isobj){

if(item.type=='新人代金券'){
if(this.totalMoney>=100){

console.log('keyix ');
if(this.activeVoucherIndex != index){
this.activeVoucherIndex = index
this.voucherPrice = item.amt
this.voucherId = item.id
}else{
this.activeVoucherIndex = -1
this.voucherPrice = ''
this.voucherId = undefined
}

}else{
this.$vux.toast.show({
type: 'warn',
text: `当前新人代金券满100才能使用`,
time:1000
})
}
}else{
console.log('item',item);
if(item.enablingAmount<=this.totalMoney){
console.log('keyi ');
if(this.activeVoucherIndex != index){
this.activeVoucherIndex = index
this.voucherPrice = item.amt
this.voucherId = item.id
}else{
this.activeVoucherIndex = -1
this.voucherPrice = ''
this.voucherId = undefined
}
}else{


this.$vux.toast.show({
type: 'warn',
text: `当前代金券满${item.enablingAmount}才能使用`,
time:1000
})

}
}



}else{
console.log('当前卷适用于', ) //类型);

this.$vux.toast.show({
type: 'warn',
text:`该代金券仅适用于${item.range}`,

})

}






},
getAddressList () {
this.$request.post('/address/list',{
token: this.getCookie('_token')
}).then(data => {
if(data.code == 0){
this.addressData = data.obj
this.haveAddress = true
if(data.obj.length == 0){
this.haveAddress = false
}else if(data.obj.length == 1){
this.addressObj = data.obj[0]
}else{
this.addressObj = data.obj[0]
this.activeAddressIndex = 0
data.obj.forEach((item,index) => {
if(item.boolDefault == '1'){
this.addressObj = item
this.activeAddressIndex = index
}
})








}

this.getExpressPrice(this.addressObj.province,this.selectInvoiceType)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getresourceListsID(){

let ID =''

if(this.resource1==0){

ID= 'shunfeng'

}else{
ID= 'jd'
}



return ID
},


upFile(url,browseButton,container,extensions) {
console.log('url',url);



let that = this;

$('.moxie-shim-html5').remove();
var accessid = ''
var accesskey = ''
var host = ''
var policyBase64 = ''
var signature = ''
var callbackbody = ''
var filename = ''
var key = ''
var expire = 0
var g_object_name = ''
var g_object_name_type = ''
var timestamp = Date.parse(new Date()) / 1000;
var now = timestamp;

function check_object_radio() {
var tt = document.getElementsByName('myradio');
for (var i = 0; i < tt.length; i++) {
if (tt[i].checked) {
g_object_name_type = tt[i].value;
break;
}
}
}

function get_signature() {


console.log('that.ossKey',that.ossKey);



now = timestamp = Date.parse(new Date()) / 1000;
if (expire < now + 3) {




host = that.ossKey['host']

policyBase64 = that.ossKey['policy']
accessid = that.ossKey['accessid']
signature = that.ossKey['signature']
expire =  that.ossKey['expire']

key = that.ossKey['dir'] 

return true;
}
return false;
};

function random_string(len) {
len = len || 32;
var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
var maxPos = chars.length;
var pwd = '';
for (let i = 0; i < len; i++) {
pwd += chars.charAt(Math.floor(Math.random() * maxPos));
}
return pwd;
}

function get_suffix(filename) {
let pos = filename.lastIndexOf('.')
let suffix = ''
if (pos != -1) {
suffix = filename.substring(pos)
}
return suffix;
}

function calculate_object_name(filename) {
if (g_object_name_type == 'local_name') {
g_object_name += "${filename}"
}
else if (g_object_name_type == 'random_name') {
let suffix = get_suffix(filename)
g_object_name = key + random_string(10) + suffix
}
return ''
}



function get_uploaded_object_name(filename) {
if (g_object_name_type == 'local_name') {
let tmp_name = g_object_name
tmp_name = tmp_name.replace("${filename}", filename);
return tmp_name
}
else if (g_object_name_type == 'random_name') {
return g_object_name
}
}

function set_upload_param(up, filename, ret) {
if (ret == false) {
ret = get_signature()
}
g_object_name = key;
if (filename != '') {
let suffix = get_suffix(filename)
calculate_object_name(filename)
}
let new_multipart_params = {
'key': g_object_name,
'policy': policyBase64,
'OSSAccessKeyId': accessid,
'success_action_status': '200', //让服务端返回200,不然，默认会返回204

'signature': signature,
};

up.setOption({
'url': host,
'multipart_params': new_multipart_params
});

up.start();

}







let uploadStartTime = '';

var uploader = new plupload.Uploader({
runtimes: 'html5,flash,silverlight,html4',

browse_button: browseButton,
multi_selection: false,

container: document.getElementById(container),
flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
url: 'http://oss.aliyuncs.com',

filters: {

mime_types: [],
max_file_size: '100mb', //最大只能上传100mb的文件
prevent_duplicates: false
},

max_retries: 3, //请求错误时的重试次数，为0时表示不重试

init: {
PostInit:()=> {





},

FilesAdded:  (up, files)=> {

uploadStartTime = Date.parse(new Date());

let ext = files[0].name.split('.')[1].toLowerCase();










this.uploadPercent = 0
set_upload_param(uploader, '', false);





},

BeforeUpload: function (up, file) {
check_object_radio();
set_upload_param(up, file.name, true);
},

UploadProgress:  (up, file)=> {



this.uploadPercent = file.percent










},

FileUploaded:  (up, file, info) =>{

if (info.status == 200) {
var ossPath = host + '/' + get_uploaded_object_name(file.name);
console.log(ossPath)

this.uploadTime = Date.parse(new Date()) - uploadStartTime



console.log('ossPath',ossPath,file.name);

this.enclosurePath=ossPath
this.enclosureName=file.name



}
},

Error: function (up, err) {
if(err.code == -600){
document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了"));
}else if(err.code == -601){
document.getElementById('console').appendChild(document.createTextNode("\n选择的文件后缀不对"));
}else if(err.code == -602){
document.getElementById('console').appendChild(document.createTextNode("\n这个文件已经上传过一遍了"));
}else{
document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
}
}
}
});

uploader.init();
setTimeout(() => {
this.$request.post(url,{}).then((response) => {
console.log(response);
if (response.code == 0) {
that.ossKey = response.obj
}else {
return;
}
})
}, 0);

},
getExpressPrice (province,invoiceType) {  //获取快递费的函数
this.$request.post('/cart/getExpressPrice',{
token: this.getCookie('_token'),
cartType: this.$route.query.cartType,
code: this.getresourceListsID(),
province,
invoiceType
}).then(data => {
if(data.code == 0){

if(this.resource==0){
this.expressPrice = data.obj

}else{
this.expressPrice = 0
}


}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getListOrder () {

this.$request.post('/cart/listOrder',{
token: this.getCookie('_token'),
cartType: this.$route.query.cartType
}).then(data => {
if(data.code == 0){
data.obj.map((item, index) => {
item.goodsIndex = index
item.singlePrice = item.salePrice*1000 * item.qty*1000/1000000
})
this.orderList = data.obj
let obj = {}
this.deliveryTimeList = data.obj.reduce((cur,next) => {
obj[next.deliveryDays] ? "" : obj[next.deliveryDays] = true && cur.push(next);
return cur;
},[])

let pyFlag = this.deliveryTimeList.every((item, index) => {
return item.surface.indexOf('无') != -1
})
let jsFlag = this.deliveryTimeList.some((item, index) => {
return item.manufactureName == 'SLM'
})
if(!pyFlag){
this.deliveryTimeList = this.deliveryTimeList.filter((item, index) => {
return item.deliveryDays >= 5
})
}
if(jsFlag){
this.deliveryTimeList = this.deliveryTimeList.filter((item, index) => {
return item.deliveryDays >= 7
})
}
console.log(JSON.parse(JSON.stringify(this.deliveryTimeList)))
this.selectedDeliveryDaysIndex = 0
this.selectedDeliveryDaysItem = this.deliveryTimeList[0]

if(data.obj.length == 0){
this.showConfirm = true
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})


this.getAddressList()
},
selectDeliveryDays (item, index) {
this.selectedDeliveryDaysIndex = index
this.selectedDeliveryDaysItem = item
},
selectInvoice () {


this.$router.push({
path: `/invoiceEditing?payAmount=${this.payAmount}&addressObjID=${this.addressObj.id?this.addressObj.id:''}`
})

},
changeAddress () {
this.showAddress = true
},
onCancel () {
this.$router.push({
path: '/shoppingCart'
})
},
onConfirm () {
this.$router.push({
path: '/shop'
})
},
addAddress () {
if(this.addressData.length >= 4){
this.$vux.toast.show({
type: 'warn',
text: '不能添加更多地址'
})
return false;
}else{
this.NewAddressData = {
token: this.$token,
address: [],
receiver: '',
province: '',
city: '',
district: '',
detail: '',
phone: '',
tel: '-',
}
this.isDefaultAddress = false
this.$request.post('/user/getPhone',{
token: this.getCookie('_token')
}).then(data => {
if(data.code == 0){
this.NewAddressData.phone = data.obj
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
this.showNewAddress = true
}
},

xgresource(val){


console.log('this.addressObj.province',this.addressObj.province);

if(this.addressObj.province){
this.resource=val
}else{




this.$vux.toast.show({
type: 'warn',
text: '添加收货地址'
})
}


},
changesecrecy(){
this.issecrecy=true
},
getsecrecy(){

let name =''

for(let i=0;i<this.secrecylists.length;i++){

if(this.secrecylists[i].code==this.secrecy){

name=this.secrecylists[i].name
break
}

}

return name

},
getboolDrawingSecrecy(){



this.$request.post('/user/getMyOrderInfo',{

}).then(data => {
if(data.code == 0){
if(data.obj.boolDrawingSecrecy=='0'){
this.secrecy='0'
}else{
this.secrecy='2'
}
}
})





},
xgresource1(val){
if(this.addressObj.province){
this.resource1=val
}else{

this.$vux.toast.show({
type: 'warn',
text: '添加收货地址'
})

}



},

editAddress () {
this.$router.push({
path: '/myAddress'
})
},
singleDel (item,index) {
this.confirmType = 'singleDel'
this.show = true
this.singleDelItem = item
this.singleDelIndex = index
},
onConfirmDel () {  // 确定删除
this.deling = true
if(this.confirmType == 'singleDel'){  //单个删除
console.log(this.singleDelItem)
console.log(this.singleDelIndex)
this.$request.post('/cart/deleteById',{
token: this.getCookie('_token'),
id: this.singleDelItem.id
}).then(data => {
if(data.code == 0){
this.getExpressPrice(this.addressObj.province,this.selectInvoiceType)
this.orderList.splice(this.singleDelIndex,1)

if(this.orderList.length == 0){
this.$vux.toast.show({
type: 'success',
text: '已删除',
time: 1000
})



this.showConfirm = true
}else{
this.showConfirm = false
}
this.deling = false
this.$vux.toast.show({
type: 'success',
text: '已删除'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
closeInvoiceBox () {  //关闭开发票弹框
this.showMoreInvoice = false
this.selectInvoiceType = ''
this.selectInvoiceTitle = ''
this.getExpressPrice(this.addressObj.province,this.selectInvoiceType)
},
selectedInvoice () {  //填好信息 确定发票按钮
if(this.selectInvoiceType == ''){
this.$vux.toast.show({
type: 'warn',
text: '请选择发票类型'
})
return false;
}
if(this.selectInvoiceType == '普通发票' || this.selectInvoiceType == '收据'){
switch (this.selectInvoiceTitle) {
case '' :
this.$vux.toast.show({
type: 'warn',
text: '请选择发票抬头'
})
return false
break;
case '个人' :
if(this.$trim(this.invoiceData.title) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入名称'
})
return false;
}
if(this.$trim(this.invoiceData.shoujihao) == '' && this.$trim(this.invoiceData.youxiang) == ''){
this.$vux.toast.show({
type: 'warn',
text: '手机号与邮箱至少填一项'
})
return false;
}
if(this.$trim(this.invoiceData.shoujihao) != '' && !this.phoneReg.test(this.$trim(this.invoiceData.shoujihao))){
this.$vux.toast.show({
type: 'warn',
text: '手机号格式有误'
})
return false;
}
var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
if(this.$trim(this.invoiceData.youxiang) != '' && !reg.test(this.$trim(this.invoiceData.youxiang))){
this.$vux.toast.show({
type: 'warn',
text: '邮箱格式有误'
})
return false;
}
if(this.selectInvoiceType == '普通发票' && !this.accessoryInfo.imgUrl){
this.$vux.toast.show({
type: 'warn',
text: '请上传附件'
})
return false;
}
break;
case '公司' :
if(this.$trim(this.invoiceData.title) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入名称'
})
return false;
}
if(this.$trim(this.invoiceData.shoujihao) == '' && this.$trim(this.invoiceData.youxiang) == ''){
this.$vux.toast.show({
type: 'warn',
text: '手机号与邮箱至少填一项'
})
return false;
}
if(this.$trim(this.invoiceData.shoujihao) != '' && !this.phoneReg.test(this.$trim(this.invoiceData.shoujihao))){
this.$vux.toast.show({
type: 'warn',
text: '手机号格式有误'
})
return false;
}
var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
if(this.$trim(this.invoiceData.youxiang) != '' && !reg.test(this.$trim(this.invoiceData.youxiang))){
this.$vux.toast.show({
type: 'warn',
text: '邮箱格式有误'
})
return false;
}
if(this.$trim(this.invoiceData.taxNum) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入纳税人识别号'
})
return false;
}else if(this.$trim(this.invoiceData.taxNum).length != 15 && this.$trim(this.invoiceData.taxNum).length != 18 && this.$trim(this.invoiceData.taxNum).length != 20){
console.log(this.$trim(this.invoiceData.taxNum).length)
this.$vux.toast.show({
type: 'warn',
text: '纳税人识别号长度为15/18/20位数字或字母',
time: 5000
})
return false;
}
if(this.selectInvoiceType == '普通发票' && !this.accessoryInfo.imgUrl){
this.$vux.toast.show({
type: 'warn',
text: '请上传附件'
})
return false;
}
break;
}

}
if(this.selectInvoiceType == '增值税专用发票'){
if(this.$trim(this.invoiceData.title) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入名称'
})
return false;
}
if(this.$trim(this.invoiceData.taxNum) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入纳税人识别号'
})
return false;
}else if(this.$trim(this.invoiceData.taxNum).length != 15 && this.$trim(this.invoiceData.taxNum).length != 18 && this.$trim(this.invoiceData.taxNum).length != 20){
console.log(this.$trim(this.invoiceData.taxNum).length)
this.$vux.toast.show({
type: 'warn',
text: '纳税人识别号长度为15/18/20位数字或字母',
time: 5000
})
return false;
}
if(this.$trim(this.invoiceData.invoiceAddress) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入注册地址'
})
return false;
}
if(this.$trim(this.invoiceData.invoicePhone) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入注册电话'
})
return false;
}
if(this.$trim(this.invoiceData.openingBank) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入开户银行'
})
return false;
}
if(this.$trim(this.invoiceData.bankAccount) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入银行账号'
})
return false;
}
if(!this.accessoryInfo.imgUrl){
this.$vux.toast.show({
type: 'warn',
text: '请上传附件'
})
return false;
}
}
this.getExpressPrice(this.addressObj.province,this.selectInvoiceType)
this.showMoreInvoice = false
},
noteThat () {
this.$router.push({
path: '/noteThat'
})
},
getInvoiceDatas () {
this.$request.post('/invoice/getBasicByType',{
invoiceType: this.selectInvoiceType
}).then(data => {
console.log(data)
if(data.code == 0){
if(data.obj != null){
this.invoiceData = {...data.obj,invoiceAddress:data.obj.address,invoicePhone:data.obj.phone,shoujihao:data.obj.phone,youxiang:data.obj.mailbox}
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
},
ordinaryInvoice (type) {  //选择普通发票
this.selectInvoiceType = type
this.getInvoiceDatas()
},
appreciationInvoice (type) {  //增值税专用发票
this.selectInvoiceType = type
this.selectInvoiceTitle = '公司'
this.getInvoiceDatas()
},
appreciationInvoiceTips () {
this.$vux.toast.show({
type: 'warn',
text: '订单总金额未达到35元以上开不了增值税发票'
})
},
receipt (type) {  //收据
this.selectInvoiceType = type
this.getInvoiceDatas()
},
person (title) {  //个人
this.selectInvoiceTitle = title
},
company (title) {  //公司
this.selectInvoiceTitle = title
},
submitOrder () {
if(!this.tipsFLag){

if(!this.haveAddress){
this.$vux.toast.show({
type: 'warn',
text: '请先添加收货地址'
})
return false;
}
if(this.payAmount < 35 && this.selectInvoiceType == '增值税专用发票'){
this.$vux.toast.show({
type: 'warn',
text: '订单总金额未达到35元以上开不了增值税发票，请修改信息',
time: 4000
})
return false;
}

this.orderList.forEach((item, index) => {
this.cartIdsArr.push(item.id)
})

for(let i=0; i<this.orderList.length; i++){
if(this.orderList.length > 1 && i != this.orderList.length-1 && this.orderList[0].deliveryDays != this.orderList[i+1].deliveryDays){
this.showSubmitSplitOrderTipsDialog = true
return false;
}
}

this.submitOrderPostData('true')
}else{
this.showSubmitOrderTipsDialog = true
}
},
delFiles () {
this.accessoryInfo = {}
},
noSplitOrder () {
this.showSubmitSplitOrderTipsDialog = false
this.submitOrderPostData('false')
console.log(this.selectedDeliveryDaysItem.deliveryDays)
},
splitOrder () {
this.showSubmitSplitOrderTipsDialog = false
this.submitOrderPostData('true')
},
getinvoiceIditem(){

if(localStorage.getItem('invoiceIditem')){
this.invoiceIditem=  JSON.parse(localStorage.getItem('invoiceIditem'))
this.selectInvoiceType=this.invoiceIditem.invoiceType

this.selectInvoiceTitle=this.invoiceIditem.title
}

},
submitOrderPostData (boolSplitOrder) {
this.$vux.loading.show({
text: '数据提交中'
})
let postData = {
address: this.addressObj.province + this.addressObj.city + this.addressObj.district + this.addressObj.detail, //收货地址
addressId: this.addressObj.id, //地址id
boolSplitOrder,
cartIds: this.cartIdsArr,                  //商品id集合
cartType: this.$route.query.cartType, //购物车类型（加入购物车、立即购买）
couponDetailId: this.voucherId==undefined?'':this.voucherId, //代金券
province: this.addressObj.province,   //省份
receiver: this.addressObj.receiver,   //收货
phone: this.addressObj.phone,         //收货人联系电话
expressAmt: this.expressPrice,        //快递费




expressPayType: this.resource+'', //快递方式   '0'   '1'    '2'
expressCode:this.getresourceListsID(),  //快递公司
boolDrawingSecrecy:this.secrecy,//保密  0  1  2
invoiceId:this.invoiceIditem.id?this.invoiceIditem.id:'',//发票
remarks:this.remarks,  //备注
integralAmt:this.integralAmt,//积分
enclosureName:this.enclosureName,
enclosurePath:this.enclosurePath,



}



if(boolSplitOrder == 'false'){
postData.deliveryDays = this.selectedDeliveryDaysItem.deliveryDays
}


console.log('postData---------------------',postData);
this.$request.post('/cart/toOrder',postData).then(data => {
console.log(data)
if(data.code == 0){
this.$vux.loading.hide()
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: data.obj
}
})

localStorage.setItem('invoiceIditem','')

}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {



this.$vux.loading.hide()
console.log(e)
this.$vux.toast.show({
type: 'cancel',
text: e.msg
})
})
}
},

created () {


this.getinvoiceIditem()
this.getListOrder()
this.getVoucher()
this.submitOrderTips()
this.getboolDrawingSecrecy()
},
computed: {
totalMoney () { //计算全部商品总价
let totalPrice = 0
this.orderList.forEach((item, index) => {
totalPrice = (totalPrice*1000 + Number(item.singlePrice)*1000)/1000
})
return totalPrice
},
totalPromotionPrice () { //计算全部商品折扣价
let totalPrice = this.totalPriceZkj
if(this.$route.query.type != 'productCenter'){
this.orderList.forEach((item, index) => {
totalPrice = (totalPrice*1000 + (Number(item.promotionPrice) * Number(item.qty))*1000)/1000
})
}else{
let zkj = 0
let spuCodeStr = ''
this.orderList.forEach((item, index) => {
zkj = (zkj*1000 + (Number(item.salePrice) * Number(item.qty))*1000)/1000
spuCodeStr += item.spuId+','
})
this.$request.post('/order/getFullDiscount',{   //满减
amt: zkj,
spuCode: spuCodeStr
}).then(data => {
console.log(data)
if(data.code == 0){
this.totalPriceZkj = data.obj
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
}
return totalPrice
},
totalDiscount: {  //已优惠
get () {
let price = this.voucherPrice
price = (price*1000 + Number(this.totalMoney)*1000 - Number(this.totalPromotionPrice)*1000)/1000
if(price > this.totalMoney){
price = this.totalMoney
}
return price
},
set (val) {
console.log(val)
this.voucherPrice = val
}
},
payAmount: {

get () {
let price = -this.voucherPrice
price += (Number(this.totalPromotionPrice) * 10000 + Number(this.expressPrice) * 10000) / 10000
if(price < this.expressPrice){
price = this.expressPrice
}
return price
},
set (val) {
console.log(val)
this.totalDiscount = val
}



}
},
watch: {
payAmount: function() {

console.log(this.payAmount);

if (this.payAmount < 35) {



}
},


resource: function() {


this.getExpressPrice(this.addressObj.province, this.invoiceType);

},



resource1: function() {


this.getExpressPrice(this.addressObj.province, this.invoiceType);

},

}
}



// WEBPACK FOOTER //
// ./src/views/submitOrder/script.js